import axios from 'axios'
import { surveyAccessConfig } from '~/utils/surveyAnswerSetAccess'

export const state = {
  SurveyAnswers: []
}
export const getters = {
  surveyAnswers: (state) => {
    return state.SurveyAnswers
  },
  surveyAnswerById: (state) => (surveyAnswerId) => {
    return state.SurveyAnswers.find(surveyAnswer => surveyAnswer.id === surveyAnswerId)
  },
  surveyAnswersByIds: (state) => (surveyAnswerIds) => {
    return state.SurveyAnswers.filter(surveyAnswer => surveyAnswerIds.indexOf(surveyAnswer.id) > -1)
  }
}

export const mutations = {
  surveyAnswers (state, surveyAnswers) {
    state.SurveyAnswers = surveyAnswers
  },
  surveyAnswerPatch (state, surveyAnswer) {
    const index = state.SurveyAnswers.findIndex(item => item.id === surveyAnswer.id)
    if (index > -1) {
      state.SurveyAnswers.splice(index, 1, surveyAnswer)
    } else {
      state.SurveyAnswers.push(surveyAnswer)
    }
  },
  surveyAnswerDelete (state, surveyAnswerId) {
    const index = state.SurveyAnswers.findIndex(item => item.id === surveyAnswerId)
    if (index > -1) {
      state.SurveyAnswers.splice(index, 1)
    }
  }
}

export const actions = {
  async surveyAnswerById (store, surveyAnswerId) {
    const { data } = await axios.get('/api/survey-answers/' + surveyAnswerId)
    store.commit('surveyAnswerPatch', data)
    return data
  },
  async surveyAnswers (store, params = {}) {
    if (!params.page) {
      params.page = 1
    }
    const { data } = await axios.get('/api/survey-answers', { params: params })

    store.commit('surveyAnswers', data.data)
    return data
  },
  async surveyAnswerDelete (store, surveyAnswerId) {
    await axios.delete('/api/survey-answers/' + surveyAnswerId)
    store.commit('surveyAnswerDelete', surveyAnswerId)
  },
  async surveyAnswerCreate (store, payload = {}) {
    const { data } = await axios.post(
      '/api/survey-answers',
      payload,
      surveyAccessConfig(payload.survey_answer_set_id)
    )
    store.commit('surveyAnswerPatch', data)
    return data
  },
  async surveyAnswerPatch (store, payload = {}) {
    const { data } = await axios.patch('/api/survey-answers/' + payload.id, payload)
    store.commit('surveyAnswerPatch', data)
    return data
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
